<template>
    <div class="loginbg" style="display: none;" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form @submit.prevent="attemptResetPassword();" id="ResetPasswordCustomerForm" name="form">
                            <h2> Reset Password </h2>
                            <div class="form-group">
                                <label for="username">Password<span class="text-danger">*</span></label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password" placeholder="">
                                <span class="help is-danger">{{frontendErrors.password}}</span>
                            </div>
                            <div class="form-group">
                                <label for="username">Confirm Password<span class="text-danger">*</span></label>
                                <input v-model="cpassword" type="password" name="cpassword" class="form-control" id="cpassword" placeholder="">
                                <span class="help is-danger">{{frontendErrors.cpassword}}</span>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                                <font class="text-danger"> <label id="errorMsg" class="error text-danger"></label><br> </font>
                            </div>
                            <div>
                                <button :disabled="disableButtons.submitButton" class="btn btn-primary" id="sendEmail">{{buttonNames.submitButton}}</button>
                                <button type="button" :disabled="disableButtons.backButton" class="btn btn-primary" v-on:click.prevent="backBtn()">{{buttonNames.backButton}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {customer_login} from '../../config';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    var self;

    export default {
        name: 'CustomerResetPassword',
        data() {
            return {
                customerToken: '',
                password: '',
                cpassword: '',
                frontendErrors: {
                    password: '',
                    cpassword: '',
                },
                buttonNames : {
                    submitButton : 'Submit',
                    backButton : 'Back',
                },
                disableButtons : {
                    submitButton : false,
                    backButton : false,
                },
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            $('#main-header').hide();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");
            $(".loginbg").show();
            self.customerToken = this.$route.params.token;
        },
        methods: {
            backBtn: function () {
                self.$router.push('/');
            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.password = "";
                self.frontendErrors.cpassword = "";
                if (!self.password) {
                    self.frontendErrors.password = 'Password Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.password != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            attemptResetPassword: function() {
                self.checkForm();
                if (self.checkForm()) {
                    self.buttonNames.submitButton = "Submiting...";
                    self.disableButtons.submitButton = true;
                    var fields = {
                        token: self.customerToken,
                        password: self.password,
                    };
                     HTTP.post("/customer/forgot/password", fields)
                        .then(function (response) {
                            self.buttonNames.submitButton = "Submit";
                            self.disableButtons.submitButton = false;
                            if (response.data.status == "success") {
                                self.backBtn();
                            }
                            if (response.data.code != 200) {
                                $('#errorMsg').html(response.data.message);
                            }
                        })
                        .catch(function (err) {
                            self.buttonNames.submitButton = "Submit";
                            self.disableButtons.submitButton = false;
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                $('#errorMsg').html(err.response.data.message);
                            }
                        });
                }
            },
        },
    }
</script>  


// WEBPACK FOOTER //
// src/components/Login/CustomerResetPassword.vue